import { ReactNode } from "react";
import { DateTimeModel, ShipmentType } from "entities/shared/shipmentCard.types";
import { Nullable, ValueOf } from "shared/lib/typeCheck.lib";

export type ProgressLineProps = {
  percent: number;
  status: "location-data" | "not-founded";
  rotation: "horizontal" | "vertical";
  className?: string;
};

export type RenderRailCardProps = {
  shipmentType: ValueOf<typeof ShipmentType>;
  etd: Nullable<DateTimeModel>;
  eta: Nullable<DateTimeModel>;
  ata: Nullable<DateTimeModel>;
  atd: Nullable<DateTimeModel>;
  count: number;
  reference: string;
  status: ValueOf<typeof RailStatusesModel>;
  directionFrom: Nullable<string>;
  directionTo: Nullable<string>;
  progressLine: ProgressLineProps;
  onOpen: () => void;
  onDelete: () => void;
};

export const RailStatusesDTO = {
  BOOKED: "BOOKED",
  RECEIVED: "RECEIVED",
  DELIVERED: "DELIVERED",
  IN_TRANSIT: "IN_TRANSIT",
  ARRIVED: "ARRIVED",
  NOTIFIED: "NOTIFIED",
  DEPARTED: "DEPARTED",
  CANCELLED: "CANCELLED",
  NULL: "NULL",
} as const;

export const RailStatusesModel = {
  UNKNOWN: "UNKNOWN",
  ...RailStatusesDTO,
} as const;

export const RailMessagesDTO = {
  OK: "OK",
  RAILWAY_COMPANY_NO_RESPONSE: "RAILWAY_COMPANY_NO_RESPONSE",
  RAILWAY_COMPANY_HASNT_PROVIDE_INFO: "RAILWAY_COMPANY_HASNT_PROVIDE_INFO",
  WRONG_RAILWAY_COMPANY: "WRONG_RAILWAY_COMPANY",
  WRONG_NUMBER: "WRONG_NUMBER",
  RAILWAY_COMPANY_NOT_SUPPORTED: "RAILWAY_COMPANY_NOT_SUPPORTED",
  RAILWAY_COMPANY_UNDER_MAINTENANCE: "RAILWAY_COMPANY_UNDER_MAINTENANCE",
  API_KEY_WRONG: "API_KEY_WRONG",
  API_KEY_ACCESS_DENIED: "API_KEY_ACCESS_DENIED",
  API_KEY_EXPIRED: "API_KEY_EXPIRED",
  API_KEY_LIMIT_REACHED: "API_KEY_LIMIT_REACHED",
  API_KEY_RATE_LIMIT: "API_KEY_RATE_LIMIT",
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR",
} as const;

export const RailMessagesModel = {
  ...RailMessagesDTO,
} as const;

export const railStatusLabelMap: Record<ValueOf<typeof RailStatusesModel>, string> = {
  [RailStatusesModel.IN_TRANSIT]: "In transit",
  [RailStatusesModel.DELIVERED]: "Delivered",
  [RailStatusesModel.BOOKED]: "Booked",
  [RailStatusesModel.RECEIVED]: "Received",
  [RailStatusesModel.ARRIVED]: "Arrived",
  [RailStatusesModel.NOTIFIED]: "Notified",
  [RailStatusesModel.UNKNOWN]: "Unknown",
  [RailStatusesModel.DEPARTED]: "Departed",
  [RailStatusesModel.CANCELLED]: "Cancelled",
  [RailStatusesModel.NULL]: "Null",
};

export type ErrorStatus = "not-defined" | "error" | "warn";

export type RenderRailSearchErrorCardProps = {
  className?: string;
  reference?: Nullable<string>;
  text?: ReactNode;
  status?: ErrorStatus;
  onRetry?: () => void;
  onDelete?: () => void;
};

export const railErrorMessageMap: Partial<Record<ValueOf<typeof RailMessagesModel>, string>> = {
  [RailMessagesModel.WRONG_NUMBER]: "Incorrect tracking number",
  [RailMessagesModel.RAILWAY_COMPANY_HASNT_PROVIDE_INFO]: "Rail operator hasn't provided info yet",
  [RailMessagesModel.RAILWAY_COMPANY_NOT_SUPPORTED]: "The rail operator is not supported at the moment",
};
